module.exports = __webpack_public_path__ + "1.4.15-unryo/img/docker.62e5c713.svg";